<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"> <CIcon name="cil-badge"/> {{ $t('reportCc') }} </span>
      </CCardHeader>
      <CCardBody>


      </CCardBody>
    </CCard>

  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "RAssessmentControl",
  components: { },

  props: {


  },
  data: function () {
    return {

    }
  },

  mounted () {

  },

  created () {
    this.onInit()

  },
  beforeDestroy () {

  },

  methods: {
    onInit(){
      this.onLoad();
    },

    onLoad(){
    },

    onOptionChange(e){
      this.option = e;
    },


  },

  computed:{
    ...mapGetters({
      lang : "setting/lang",
    }),

  },

  watch: {
    lang(value){

    },
  }

}
</script>

<style scoped>

</style>
